import { ProgramEnrollmentsV2NaptimeResource } from './__generated__/ProgramEnrollmentsV2';

export default class ProgramEnrollmentsV2 extends ProgramEnrollmentsV2NaptimeResource {
  static RESOURCE_NAME = 'programEnrollments.v2' as const;
}
